import { protectedAxios, publicAxios } from '@/lib/axiosInstance';
import {
  RegisterPayload,
  RegisterResponse,
  ResetPasswordPayload,
  SignInPayload,
  SignInResponse,
  ValidateOtpPayload,
  VerifyEmailResponse,
} from '@/types/api/auth';

export const registerUser = async (
  payload: RegisterPayload
): Promise<RegisterResponse> => {
  const response = await publicAxios.post<RegisterResponse>(
    '/auth/register',
    payload
  );
  return response.data;
};

export const signInUser = async (
  payload: SignInPayload
): Promise<SignInResponse> => {
  const response = await publicAxios.post<SignInResponse>(
    '/auth/login',
    payload
  );
  return response.data;
};

export const adminSignInUser = async (
  payload: SignInPayload
): Promise<SignInResponse> => {
  const response = await publicAxios.post<SignInResponse>(
    '/auth/admin/login',
    payload
  );
  return response.data;
};

export const validateAdminOtp = async (payload: ValidateOtpPayload) => {
  const response = await publicAxios.post('/auth/admin/verify-otp', payload);
  return response.data;
};

export const resendAdminOtp = async (email: string) => {
  const response = await publicAxios.post('/auth/admin/resend-otp', {
    email,
  });
  return response.data;
};

export const forgotPassword = async (email: string) => {
  const response = await publicAxios.post('/auth/forgot-password', {
    email,
  });
  return response.data;
};

export const resetPassword = async (payload: ResetPasswordPayload) => {
  const response = await publicAxios.post('/auth/reset-password', {
    ...payload,
  });
  return response.data;
};

export const resendVerificationEmail = async (email: string) => {
  const response = await publicAxios.post('/auth/resend-verification-mail', {
    email,
  });
  return response.data;
};

export const verifyEmail = async (
  token: string
): Promise<VerifyEmailResponse> => {
  const response = await publicAxios.post('/auth/verify-user', {
    token,
  });
  return response.data;
};

export const logoutUser = async () => {
  const response = await protectedAxios.post('/auth/logout');
  return response.data;
};
